import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=3760106a&scoped=true&"
import script from "./StackedBarChart.vue?vue&type=script&lang=js&"
export * from "./StackedBarChart.vue?vue&type=script&lang=js&"
import style0 from "./StackedBarChart.vue?vue&type=style&index=0&id=3760106a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3760106a",
  null
  
)

export default component.exports